import { Kommune, kommunerSorted as kommuner, skatKommune } from "@/util/index";
import MultipleSelectCombobox from "../MultipleSelectCombobox/MultipleSelectCombobox";
import { CSSProperties } from "react";

export type KommuneMultipleSelectComboboxProps = {
  selectedItems: Kommune[];
  setSelectedItems: (selectedItems: Kommune[]) => void;
  includeSkat?: boolean;
  showSelectedItems?: boolean;
  inputClassName?: string;
  inputStyle?: CSSProperties;
  menuClassName?: string;
  menuStyle?: CSSProperties;
};

export default function KommuneMultipleSelectCombobox(
  props: KommuneMultipleSelectComboboxProps
) {
  const { selectedItems, setSelectedItems, includeSkat } = props;

  return (
    <MultipleSelectCombobox
      selectedItems={selectedItems}
      addSelectedItem={(item: Kommune) => {
        setSelectedItems([...selectedItems, item]);
      }}
      removeSelectedItem={(item: Kommune) => {
        setSelectedItems(selectedItems.filter((k) => k.knr !== item.knr));
      }}
      inputClassName="border rounded"
      inputStyle={{
        height: 51,
        marginBottom: 0,
      }}
      menuStyle={{
        top: 50,
      }}
      getFilteredItems={(_selectedItems, inputValue) => {
        const lowerCasedInputValue = inputValue.toLowerCase();
        const skatItems: Kommune[] = includeSkat ? [skatKommune] : [];
        return [...skatItems, ...kommuner].filter(function filterKom(kom) {
          return (
            kom.navn.toLowerCase().includes(lowerCasedInputValue) ||
            kom.knr.toString().includes(lowerCasedInputValue)
          );
        });
      }}
      itemIsSelected={(item: Kommune) =>
        selectedItems.some((i) => i.knr === item.knr)
      }
      itemToString={(item) => item?.navn ?? ""}
      itemKey="knr"
    />
  );
}
